import React from 'react';
import { X, User, Sun, Moon, Search, Dice6 } from 'lucide-react';
import BaseModal from './BaseModal';
import { motion } from 'framer-motion';

interface InstructionsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const InstructionsModal: React.FC<InstructionsModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <BaseModal isOpen={isOpen} onClose={onClose} maxWidth="md">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
        transition={{ duration: 0.3 }}
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-800 dark:text-white">
            Benvingut a minijocs.cat!
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
          >
            <X size={20} />
          </button>
        </div>
        <div className="space-y-3 text-sm sm:text-base text-gray-600 dark:text-gray-300">
          <p>Aquí tens algunes instruccions per començar:</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>Pots jugar a qualsevol minijoc fent clic a la seva casella.</li>
            <li>
              Utilitza el botó de daus{' '}
              <Dice6 className="inline-block w-3 h-3 sm:w-4 sm:h-4" /> per
              accedir a un joc aleatori.
            </li>
            <li>
              Amb la lupa{' '}
              <Search className="inline-block w-3 h-3 sm:w-4 sm:h-4" /> pots
              cercar minijocs pel seu nom o descripció.
            </li>
            <li>
              El botó de perfil{' '}
              <User className="inline-block w-3 h-3 sm:w-4 sm:h-4" /> et permet
              veure la teva informació personal.
            </li>
            <li>
              Canvia l'aparença amb el botó de mode clar/fosc{' '}
              <Sun className="inline-block w-3 h-3 sm:w-4 sm:h-4" />/
              <Moon className="inline-block w-3 h-3 sm:w-4 sm:h-4" />.
            </li>
            <li>
              Pots fer donacions si t'agraden els minijocs i vols formar part
              del top de donants.
            </li>
          </ul>
          <p>Gràcies per ser part d'aquesta aventura!</p>
        </div>
        <motion.button
          onClick={onClose}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="mt-4 sm:mt-6 w-full bg-gradient-to-r from-yellow-500 to-red-500 hover:from-yellow-600 hover:to-red-600 text-white font-bold py-2 px-4 rounded-lg transition duration-300 text-sm sm:text-base"
        >
          Començar a Jugar!
        </motion.button>
      </motion.div>
    </BaseModal>
  );
};

export default InstructionsModal;
